export default "__VITE_ASSET__Du0L8ysG__"